import React, { useState } from 'react';

const MotDuDirecteur: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <section
      id="mot-directeur"
      className="py-16 bg-white dark:bg-gray-900 transition-colors duration-200 scroll-mt-24"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* En-tête de section */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
            Mot du Directeur
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-8"></div>
        </div>

        {/* Contenu principal */}
        <div className="bg-gray-50 dark:bg-gray-800 rounded-2xl p-8 lg:p-12 shadow-lg transition-colors duration-200">
          {/* Photo et signature du directeur */}
          <div className="flex flex-col lg:flex-row gap-8 mb-8">
            <div className="lg:w-1/3">
              <div className="bg-gradient-to-br from-blue-100 to-blue-200 dark:from-gray-700 dark:to-gray-600 rounded-xl p-6 h-64 flex items-center justify-center mb-4">
                <div className="text-center">
                  <div className="w-20 h-20 bg-blue-600 dark:bg-blue-500 rounded-full mx-auto mb-3 flex items-center justify-center">
                    <span className="text-white font-bold text-2xl">M</span>
                  </div>
                  <p className="text-blue-700 dark:text-blue-200 font-semibold">Macajou A. MEDARD</p>
                  <p className="text-blue-600 dark:text-blue-300 text-sm">Directeur Fondateur</p>
                </div>
              </div>
            </div>

            <div className="lg:w-2/3">
              <div className="prose prose-lg text-gray-700 dark:text-gray-300 leading-relaxed">
                <p className="text-lg font-medium text-blue-900 dark:text-blue-100 mb-4">
                  Il nous est agréable de vous présenter ce petit livret sorti en partie de notre mémoire.
                  Il permettra au lecteur de mieux connaître l'Institut, son passé, son présent, son avenir et son futur.
                </p>
              </div>
            </div>
          </div>
          {/* Corps du message */}
          <div className="prose prose-lg max-w-none text-gray-700 dark:text-gray-300 leading-relaxed space-y-6">
            <p>
              Au moment d'écrire ces lignes, nous avons une pensée spéciale pour deux personnes :{' '}
              <strong className="text-blue-900 dark:text-blue-100">le docteur Robert Germain</strong> sans lequel il n'y aurait pas d'École
              Nationale de Technologie Médicale du Cap-Haïtien (ENTMCH),{' '}
              <strong className="text-blue-900 dark:text-blue-100">le président René Préval</strong> sans lequel il n'y aurait plus l'École
              Nationale de Technologie Médicale du Cap-Haïtien devenue Institut Supérieur de Technologie Médicale du
              Cap-Haïtien (ISTMECH), par Arrêté Présidentiel du 27 janvier 2011, parue dans le Moniteur du 04 février 2011.
            </p>

            {!isExpanded && (
              <div className="text-center">
                <button
                  onClick={() => setIsExpanded(true)}
                  className="inline-flex items-center px-6 py-3 bg-blue-600 dark:bg-blue-500 text-white rounded-lg hover:bg-blue-700 dark:hover:bg-blue-600 transition-colors duration-200 shadow-lg"
                >
                  <span className="mr-2">Lire la suite</span>
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
              </div>
            )}

            {isExpanded && (
              <>
                <div className="bg-blue-50 dark:bg-blue-900/20 border-l-4 border-blue-600 dark:border-blue-400 p-6 my-8">
                  <p className="text-blue-900 dark:text-blue-100 font-medium">
                    Le docteur Germain est l'auteur principal de la création de l'ENTMCH, le président Préval
                    a rouvert l'École en 1998, après un silence de dix ans (1988 – 1998) et l'a élevée au rang d'Institut Supérieur.
                  </p>
                </div>

                <p>
                  La jeunesse haïtienne leur doit reconnaissance. Grâce à eux, <strong className="text-green-600 dark:text-green-400">plus de deux cent
                    cinquante jeunes</strong> exercent aujourd'hui une profession et peuvent voler de leurs propres ailes.
                  Leur parcours est retracé dans ce livret.
                </p>

                <p>
                  Comment ne pas penser également à ces <strong className="text-blue-900 dark:text-blue-100">huit professeurs</strong> qui ont accepté de se
                  lancer dans ce qui, au début, en 1984, était considéré comme une aventure pour le moins périlleuse.
                  Certains ont rempli leur tâche bénévolement. Ils doivent se réjouir, aujourd'hui, de constater que
                  cette aventure a enfanté une institution sérieuse, respectée, reconnue internationalement,
                  <strong className="text-green-600 dark:text-green-400"> la meilleure du pays en la matière, parmi les meilleures de la Caraïbe</strong>.
                </p>

                <div className="bg-green-50 dark:bg-green-900/20 border-l-4 border-green-500 dark:border-green-400 p-6 my-8">
                  <p className="text-green-800 dark:text-green-100 font-medium">
                    L'ISTMECH a donné à la biologie médicale sa vraie place dans la pratique de la médecine en Haïti.
                    Il continue son chemin vers l'excellence.
                  </p>
                </div>

                <p>
                  Que ceux qui ont contribué à sa survie et à son ascension soient remerciés. Merci à
                  <strong className="text-blue-900 dark:text-blue-100">Frantz M. Marthol</strong>, notre adjoint, notre fidèle collaborateur.
                  Merci à l'<strong className="text-blue-900 dark:text-blue-100">International Training and Education Center for Health en haïti
                    (I-TECH haïti)</strong> pour son assistance non négligeable.
                </p>

                <p>
                  L'heure de la retraite a sonné pour nous. Nous laissons la place à une relève préparée et bien
                  imbue de ses responsabilités. C'est dire que <strong className="text-blue-900 dark:text-blue-100">l'ISTMECH met le cap sur un siècle de succès</strong>.
                </p>

                <div className="bg-gray-100 dark:bg-gray-700 rounded-lg p-6 my-8 text-center">
                  <p className="text-gray-800 dark:text-gray-200 font-medium italic">
                    Après trente ans de bons et loyaux services comme Chef de Laboratoire, après vingt-neuf ans
                    d'excellents services et de bénévolat comme Cofondateur et Directeur de l'ISTMECH, nous pouvons
                    nous en aller avec la satisfaction du devoir accompli.
                  </p>
                  <p className="text-blue-900 dark:text-blue-100 font-bold mt-4">
                    Nous partons avec le sourire.
                  </p>
                </div>

                <div className="text-center">
                  <button
                    onClick={() => setIsExpanded(false)}
                    className="inline-flex items-center px-6 py-3 bg-gray-600 dark:bg-gray-500 text-white rounded-lg hover:bg-gray-700 dark:hover:bg-gray-600 transition-colors duration-200 shadow-lg"
                  >
                    <span className="mr-2">Voir moins</span>
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                    </svg>
                  </button>
                </div>
              </>
            )}
          </div>

          {/* Signature */}
          <div className="text-right mt-8 pt-6 border-t border-gray-200 dark:border-gray-600">
            <div className="inline-block">
              <p className="text-xl font-bold text-gray-900 dark:text-white">Macajou A. MEDARD</p>
              <p className="text-blue-600 dark:text-blue-400 font-medium">Directeur Fondateur - ISTMECH</p>
              <p className="text-gray-500 dark:text-gray-400 text-sm mt-1">29 années de service (1984-2013)</p>
            </div>
          </div>
        </div>

        {/* Statistiques clés */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
          <div className="bg-blue-600 dark:bg-blue-500 text-white rounded-xl p-6 text-center">
            <div className="text-3xl font-bold mb-2">1984</div>
            <div className="text-blue-100 dark:text-blue-200">Année de création</div>
          </div>
          <div className="bg-green-600 dark:bg-green-500 text-white rounded-xl p-6 text-center">
            <div className="text-3xl font-bold mb-2">250+</div>
            <div className="text-green-100 dark:text-green-200">Diplômés formés</div>
          </div>
          <div className="bg-purple-600 dark:bg-purple-500 text-white rounded-xl p-6 text-center">
            <div className="text-3xl font-bold mb-2">2011</div>
            <div className="text-purple-100 dark:text-purple-200">Élévation au rang d'Institut</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MotDuDirecteur;
